var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco2Proceso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico_2_proceso",
    transform: "translate(-642 -1911)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8129",
    "data-name": "Group 8129",
    transform: "translate(664.64 1929.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19649",
    "data-name": "Path 19649",
    d: "M1128.642,440.881v7.08a12.452,12.452,0,0,0,5.678,10.449l60.816,39.423a11.4,11.4,0,0,1,5.2,9.564v20.038h11.2V507.4a11.4,11.4,0,0,1,5.2-9.564l60.816-39.423a12.453,12.453,0,0,0,5.679-10.449v-7.08Z",
    transform: "translate(-1102.785 -358.918)",
    fill: "#80cfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19650",
    "data-name": "Path 19650",
    d: "M1260.583,414.273V434.7a9.918,9.918,0,0,1-4.54,8.353l-66.372,43.025a16.016,16.016,0,0,0-7.33,13.487v18.233h-12.032V499.56a16.017,16.017,0,0,0-7.33-13.487l-66.373-43.025a9.917,9.917,0,0,1-4.539-8.353V401.511H1084.8V434.7a17.16,17.16,0,0,0,7.856,14.454l66.372,43.025a8.771,8.771,0,0,1,4.014,7.386v25.5h26.572v-25.5a8.77,8.77,0,0,1,4.015-7.386L1260,449.149a17.164,17.164,0,0,0,7.855-14.454V414.273Z",
    transform: "translate(-1084.796 -342.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8128",
    "data-name": "Group 8128",
    transform: "translate(45.642 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19651",
    "data-name": "Path 19651",
    d: "M1260.529,348.043c4.437,5.522,8.93,10.615,11.465,17,2.236,5.625-2.328,12.817-8.87,14.233a11.835,11.835,0,0,1-14.449-11.322,13.675,13.675,0,0,1,1.806-5.774,47.49,47.49,0,0,1,4.061-6.422C1256.376,353.211,1258.381,350.792,1260.529,348.043Zm.38,9.312-.768-.007c-1.689,2.766-3.494,5.47-5.03,8.319a5.3,5.3,0,0,0,1.717,6.621,6.08,6.08,0,0,0,7.4,0,5.3,5.3,0,0,0,1.713-6.628C1264.408,362.817,1262.6,360.118,1260.909,357.355Z",
    transform: "translate(-1197.672 -320.829)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19652",
    "data-name": "Path 19652",
    d: "M1217.105,301.9c4.646,5.8,9.2,10.921,11.709,17.392,1.86,4.8-1.483,11.182-6.825,13.436-7.788,3.285-16.642-2.41-16.5-10.835a12.463,12.463,0,0,1,2.041-6.059C1210.456,311.195,1213.72,306.773,1217.105,301.9Zm.63,9.48-.79.035c-1.75,2.924-3.642,5.776-5.2,8.8-1.054,2.045-.008,4.738,1.978,6.241a6,6,0,0,0,6.945.189c2.071-1.41,3.35-4.116,2.361-6.12C1221.474,317.37,1219.52,314.415,1217.736,311.377Z",
    transform: "translate(-1179.954 -301.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19653",
    "data-name": "Path 19653",
    d: "M1303.71,302.374c4.1,5.106,7.909,9.967,10.892,15.5,2.994,5.555-.8,14.481-8.769,15.761a11.829,11.829,0,0,1-14.052-11.112,7.3,7.3,0,0,1,.521-3.172C1294.855,312.966,1299.326,307.869,1303.71,302.374Zm.39,9.238-.794-.038c-1.785,3.036-3.737,5.99-5.292,9.14-.983,1.991.308,4.735,2.356,6.13a6,6,0,0,0,6.943-.205c2-1.525,3.047-4.2,1.994-6.239C1307.748,317.38,1305.852,314.533,1304.1,311.612Z",
    transform: "translate(-1215.35 -302.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19654",
    "data-name": "Path 19654",
    d: "M1174.107,348.138c4.385,5.45,8.86,10.548,11.41,16.931,1.955,4.892-1.461,11.51-6.928,13.675a11.942,11.942,0,0,1-16.4-10.738,6.987,6.987,0,0,1,.4-2.658C1165.14,358.829,1169.667,353.647,1174.107,348.138Zm.32,9.24-.74,0c-1.692,2.772-3.5,5.48-5.038,8.335a5.239,5.239,0,0,0,1.722,6.611,6.048,6.048,0,0,0,7.4,0,5.252,5.252,0,0,0,1.71-6.62C1177.94,362.851,1176.125,360.146,1174.428,357.378Z",
    transform: "translate(-1162.19 -320.868)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ico_1_proceso",
    transform: "translate(642 1911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6458",
    "data-name": "Rectangle 6458",
    width: 228,
    height: 228,
    transform: "translate(0)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 107.233,
    cy: 107.233,
    r: 107.233,
    transform: "translate(649 1915)",
    fill: "#fff",
    opacity: 0.23,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco2Proceso);
export default __webpack_public_path__ + "static/media/ico_2_proceso.0973702da8d4b401a01f7024714c8176.svg";
export { ForwardRef as ReactComponent };